import { useEffect, useState } from "react";
import API from "../services/api";

export default function CEOReports() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [managers, setManagers] = useState([]);

  const [filters, setFilters] = useState({
    manager_id: "",
    status: "",
    from: "",
    to: ""
  });

  const format = (num) => Number(num || 0).toLocaleString();

  const load = async () => {
    const query = new URLSearchParams(
      Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))
    ).toString();

    const res = await API.get(`/ceo/report?${query}`);
    setData(res.data.data || []);
    setSummary(res.data.summary || {});
  };

  const loadManagers = async () => {
    const res = await API.get("/ceo/managers");
    setManagers(res.data || []);
  };

  useEffect(() => {
    load();
    loadManagers();
  }, []);

  return (
    <div style={{ padding: 16, background: "#f4f6f9", minHeight: "100vh" }}>

      <h2 style={{ marginBottom: 15 }}>👑 CEO Reports</h2>

      {/* FILTER */}
      <div style={filterBox}>
        <select onChange={(e) =>
          setFilters({ ...filters, manager_id: e.target.value })
        }>
          <option value="">👨‍💼 All Managers</option>
          {managers.map(m => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>

        <select onChange={(e) =>
          setFilters({ ...filters, status: e.target.value })
        }>
          <option value="">📊 All Status</option>
          <option value="approved">✅ Approved</option>
          <option value="pending">⏳ Pending</option>
          <option value="rejected">❌ Rejected</option>
        </select>

        <input type="date" onChange={(e) => setFilters({ ...filters, from: e.target.value })} />
        <input type="date" onChange={(e) => setFilters({ ...filters, to: e.target.value })} />

        <button onClick={load} style={btn}>🔍 Apply</button>
      </div>

      {/* SUMMARY CARDS */}
      <div style={cardGrid}>
        <Card title="Total Claims" value={summary.totalClaims} icon="📦" color="#3498db" />
        <Card title="Total Amount" value={`Rs ${format(summary.totalAmount)}`} icon="💰" color="#2ecc71" />
        <Card title="Approved" value={`Rs ${format(summary.approvedAmount)}`} icon="✅" color="#27ae60" />
        <Card title="Pending" value={`Rs ${format(summary.pendingAmount)}`} icon="⏳" color="#f39c12" />
        <Card title="Rejected" value={`Rs ${format(summary.rejectedAmount)}`} icon="❌" color="#e74c3c" />
      </div>

      {/* TABLE */}
      <div style={tableWrapper}>
        <table style={table}>
          <thead style={thead}>
            <tr>
              <th style={th}>👨‍💼 Manager</th>
              <th style={th}>🏢 Dealer</th>
              <th style={th}>👤 Salesman</th>
              <th style={th}>🧾 Customer</th>
              <th style={th}>💰 Amount</th>
              <th style={th}>📊 Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((c, i) => (
              <tr key={c.id} style={{
                background: i % 2 === 0 ? "#fafafa" : "#fff"
              }}>
                <td style={td}>{c.manager_name}</td>
                <td style={td}>{c.dealer_name}</td>
                <td style={td}>{c.salesman_name}</td>
                <td style={td}>{c.customer_name}</td>
                <td style={td}>Rs {format(c.claim_amount)}</td>
                <td style={td}>
                  <StatusBadge status={c.final_status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

// ================= COMPONENTS =================

const Card = ({ title, value, icon, color }) => (
  <div style={{
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    gap: 10
  }}>
    <div style={{
      fontSize: 22,
      background: color,
      color: "#fff",
      padding: 10,
      borderRadius: 10
    }}>
      {icon}
    </div>

    <div>
      <p style={{ fontSize: 12, color: "#777" }}>{title}</p>
      <h3 style={{ margin: 0 }}>{value}</h3>
    </div>
  </div>
);

const StatusBadge = ({ status }) => {
  const map = {
    approved: { color: "#27ae60", bg: "#eafaf1", text: "Approved" },
    pending: { color: "#f39c12", bg: "#fef5e7", text: "Pending" },
    rejected: { color: "#e74c3c", bg: "#fdecea", text: "Rejected" }
  };

  const s = map[status] || {};

  return (
    <span style={{
      background: s.bg,
      color: s.color,
      padding: "4px 10px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: "bold"
    }}>
      {s.text}
    </span>
  );
};

// ================= STYLES =================

const filterBox = {
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginBottom: 15,
  background: "#fff",
  padding: 10,
  borderRadius: 10,
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
};

const btn = {
  background: "#2c5178",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: 6,
  cursor: "pointer"
};

const cardGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 12,
  marginBottom: 15
};

const tableWrapper = {
  overflowX: "auto",
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
};

const table = {
  width: "100%",
  minWidth: 750,
  borderCollapse: "collapse"
};

const thead = {
  background: "#2c5178",
  color: "#fff"
};

const th = {
  padding: 12,
  textAlign: "left",
  fontSize: 13
};

const td = {
  padding: 12,
  fontSize: 13,
  borderBottom: "1px solid #eee"
};